define('similarCreateEditLayoutView',[
  'module',
  'marionette',
  'backbone',
  'jquery',
  'dialogFormView',
  'template!similarCreateEditLayoutTpl'
], function(
  module,
  Marionette,
  Backbone,
  $,
  DialogFormView,
  similarCreateEditLayoutTpl
) {
  'use strict';

  module.exports = DialogFormView.extend({
    template: similarCreateEditLayoutTpl,

    ui: {
      input: '.js-info-input',
      cancel: '.js-cancel',
      confirm: '.js-confirm'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input' : 'onFocus',
      'change @ui.input': 'onInputChange',
      'click @ui.confirm': 'onConfirm',
      'click @ui.cancel': 'onCancel'
    },

    modelEvents: {
      sync: 'onSave'
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.newItem = this.options.newItem;
      return templateData;
    },

    onShow: function() {
      $.material.init();
    },

    onConfirm: function() {
      this.model.save();
    },

    onEscape: function() {
      if (!this.newItem) {
        this.model.fetch();
        this.model = null;
      }
    },

    onCancel: function() {
      if (!this.newItem) {
        this.model.fetch();
        this.model = null;
      }
      this.hide();
    },

    onSave: function() {
      this.triggerMethod('saved');
      if (this.options.newItem) {
        this.collection.add(this.model);
        this.model = null;
      } else {
        this.model = null;
      }
      this.hide();
    }
  });
});
